var id = 0;

function _classPrivateFieldKey(name) {
  return "__private_" + id++ + "_" + name;
}

module.exports = _classPrivateFieldKey;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/classPrivateFieldLooseKey.js
// module id = 461
// module chunks = 0